module.exports = __webpack_public_path__ + "img/404.e8e541f1.svg";